import { fullPalette, grayPalette, primaryPalette, tempusPalette } from '@tcl-argon-colors/colors';
import { InputTheme } from '@tcl-argon-models/models';

export interface InputState {
  isFocused?: boolean;
  isDisabled?: boolean;
}

// TODO figure out a nice unified way of creating themes and passing them to components for styling
// This current method is simple but inelegant

export function inputThemeToIconColor(theme = InputTheme.Default) {
  if (theme === InputTheme.Error) {
    return primaryPalette.errorPrimary;
  } else if (theme === InputTheme.Success) {
    return primaryPalette.successPrimary;
  } else if (theme === InputTheme.Warning) {
    return primaryPalette.warningPrimary;
  } else if (theme === InputTheme.Tempus) {
    return primaryPalette.tempusPrimary;
  } else {
    return grayPalette.gray100;
  }
}

export function inputThemeToBannerColor(theme = InputTheme.Default) {
  if (theme === InputTheme.Error) {
    return primaryPalette.errorPrimary;
  } else if (theme === InputTheme.Success) {
    return primaryPalette.successPrimary;
  } else if (theme === InputTheme.Warning) {
    return primaryPalette.warningPrimary;
  } else {
    return grayPalette.gray100;
  }
}

export function inputThemeToAlertBackgroundColor(theme = InputTheme.Default) {
  if (theme === InputTheme.Error) {
    return fullPalette.radar30;
  } else if (theme === InputTheme.Success) {
    return fullPalette.prism10;
  } else if (theme === InputTheme.Warning) {
    return fullPalette.infrared10;
  }

  return 'white';
}

export function inputThemeToSubContentColor(theme = InputTheme.Default) {
  if (theme === InputTheme.Error) {
    return primaryPalette.errorPrimary;
  } else if (theme === InputTheme.Success) {
    return primaryPalette.successPrimary;
  } else if (theme === InputTheme.Warning) {
    return primaryPalette.warningPrimary;
  } else if (theme === InputTheme.Tempus) {
    return primaryPalette.tempusPrimary;
  } else {
    return grayPalette.gray60;
  }
}

export function inputThemeToBorderColor(theme = InputTheme.Default, state: InputState = {}) {
  const { isDisabled = false, isFocused = false } = state;

  if (isDisabled) {
    return grayPalette.gray20;
  } else if (theme === InputTheme.Error) {
    return primaryPalette.errorPrimary;
  } else if (theme === InputTheme.Success) {
    return primaryPalette.successPrimary;
  } else if (theme === InputTheme.Warning) {
    return primaryPalette.warningPrimary;
  } else if (theme === InputTheme.Tempus) {
    return primaryPalette.tempusPrimary;
  } else if (theme === InputTheme.Dark) {
    return grayPalette.gray70;
  } else if (isFocused) {
    // Focus styles have "low priority" for border
    return primaryPalette.tempusPrimary;
  }

  return grayPalette.gray20;
}

export function inputThemeToBackgroundColor(theme = InputTheme.Default, state: InputState = {}) {
  const { isDisabled = false, isFocused = false } = state;

  if (isDisabled) {
    return grayPalette.gray10;
  } else if (isFocused) {
    // Focus styles have "high priority" for background color
    return 'white';
  } else if (theme === InputTheme.Error) {
    return fullPalette.radar10;
  } else if (theme === InputTheme.Success) {
    return fullPalette.optic10;
  } else if (theme === InputTheme.Warning) {
    return fullPalette.infrared10;
  } else if (theme === InputTheme.Tempus) {
    return tempusPalette.tempus10;
  } else if (theme === InputTheme.Dark) {
    return grayPalette.gray60;
  }

  return 'white';
}

export function getThemeStyles(theme = InputTheme.Default) {
  return {
    defaultStyles: {
      backgroundColor: inputThemeToBackgroundColor(theme),
      borderColor: inputThemeToBorderColor(theme),
    },
    disabledStyles: {
      backgroundColor: inputThemeToBackgroundColor(theme, { isDisabled: true }),
      borderColor: inputThemeToBorderColor(theme, { isDisabled: true }),
    },
    focusedStyles: {
      borderColor: inputThemeToBorderColor(theme, { isFocused: true }),
      backgroundColor: 'white',
    },
  };
}
